var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { OfficeLocationFullSizeDto } from '../../offices/dto/office-location.full-size.dto.js';
import { OfficeFullSizeDto } from '../../offices/dto/office.full-size.dto.js';
import { ConnectedStripeAccountFullSizeDto } from '../../payment/dto/connected-stripe-account.full-size.dto.js';
import { UserFullSizeDto } from '../../user/dto/user.full-size.dto.js';
import { InvoiceLineFullSizeDto } from './invoice-line.full-size.dto.js';
export class InvoiceFullSizeDto {
    id;
    createdAt;
    updatedAt;
    effectiveAt;
    rawData;
    dueDate;
    invoiceNumber;
    stripeId;
    total;
    pdfLink;
    user;
    userId;
    officeLocation;
    officeLocationId;
    office;
    officeId;
    lines;
    isPaid;
    connectedStripeAccountId;
    connectedStripeAccount;
    stripeAccountId;
    officeProductAssignmentsAsPatientInvoice = [];
    officeProductAssignmentsAsApplicationFeeInvoice = [];
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], InvoiceFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], InvoiceFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], InvoiceFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "effectiveAt", void 0);
__decorate([
    IsString(),
    Exclude(),
    __metadata("design:type", String)
], InvoiceFullSizeDto.prototype, "rawData", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "dueDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "invoiceNumber", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], InvoiceFullSizeDto.prototype, "stripeId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], InvoiceFullSizeDto.prototype, "total", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], InvoiceFullSizeDto.prototype, "pdfLink", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    Type(() => UserFullSizeDto),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "user", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLocationFullSizeDto),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "officeLocation", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeFullSizeDto),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "office", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "officeId", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => InvoiceLineFullSizeDto),
    __metadata("design:type", Array)
], InvoiceFullSizeDto.prototype, "lines", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], InvoiceFullSizeDto.prototype, "isPaid", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    IsObject(),
    Exclude(),
    IsOptional(),
    Type(() => ConnectedStripeAccountFullSizeDto),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "connectedStripeAccount", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], InvoiceFullSizeDto.prototype, "stripeAccountId", void 0);
__decorate([
    Exclude(),
    IsArray(),
    __metadata("design:type", Array)
], InvoiceFullSizeDto.prototype, "officeProductAssignmentsAsPatientInvoice", void 0);
__decorate([
    Exclude(),
    IsArray(),
    __metadata("design:type", Array)
], InvoiceFullSizeDto.prototype, "officeProductAssignmentsAsApplicationFeeInvoice", void 0);
//# sourceMappingURL=invoice.full-size.dto.js.map